import React from "react";

export default function Package() {
    return (
        <div>
            <h2>Package</h2>
            <p>Manage subscription packages here.</p>
        </div>
    );
}
